export default __webpack_public_path__ + "static/media/a68c48be24f2791e7d349e7013f1981c1598963845714.1fbefda2.webp";